import React from 'react';
import { HiveCoreScenePanel } from '../../components/HiveCore/HiveCoreScenePanel';

/**
 * Clean test route for HiveCore Scene Composer connection
 * This route bypasses the legacy editor WebSocket to validate
 * the HiveCoreProvider and binding layer independently
 */
export default function HiveCoreControlPage() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-6">
            <div className="max-w-7xl mx-auto">
                <div className="mb-6">
                    <h1 className="text-3xl font-bold text-white mb-2">
                        HiveCore Scene Composer Test
                    </h1>
                    <p className="text-slate-400">
                        Testing HiveCoreProvider connection to Scene Composer with binding layer
                    </p>
                </div>

                <HiveCoreScenePanel />

                <div className="mt-6 p-4 bg-slate-800/50 rounded-lg border border-slate-700/50">
                    <h3 className="text-lg font-semibold text-white mb-2">Connection Details</h3>
                    <div className="space-y-1 text-sm text-slate-300">
                        <p>
                            <span className="text-slate-500">Backend URL:</span>{' '}
                            {import.meta.env.VITE_HIVECORE_API_URL ||
                                import.meta.env.VITE_BACKEND_URL ||
                                'https://hivecore-backend-production.up.railway.app'}
                        </p>
                        <p>
                            <span className="text-slate-500">Socket.IO Path:</span> /socket.io
                        </p>
                        <p>
                            <span className="text-slate-500">Namespace:</span> /abda
                        </p>
                        <p>
                            <span className="text-slate-500">Scene ID:</span> hivecore.control
                        </p>
                        <p>
                            <span className="text-slate-500">Profile:</span> desktop
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
